import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { Typography } from '@material-tailwind/react';
import Button from '../../buttons/button';
import {
  type BaseProps,
  ComponentAppearance,
  ComponentSize,
} from 'src/modules/shared/types/component.type';

interface ErrorStateProps extends BaseProps {
  title?: string;
  description?: string;
  onAction?: () => void;
  actionContent?: React.ReactNode;
  size?: ComponentSize;
  appearance?: ComponentAppearance;
  placement?: 'horizontal' | 'vertical';
}

// TODO: check when implementing i18n
export const ErrorState: React.FC<ErrorStateProps> = ({
  className = '',
  title = 'Algo salió mal',
  description = 'Ocurrió un error inesperado',
  onAction,
  actionContent = 'Intentar de nuevo',
  variant = 'primary',
  appearance = 'filled',
  size = 'md',
  placement = 'vertical',
}) => {
  const iconSizeClasses = {
    '2xs': 'w-4 h-4',
    xs: 'w-5 h-5',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
  };

  const textSizeClasses = {
    '2xs': 'text-xs',
    xs: 'text-sm',
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-xl',
  };

  const descriptionSizeClasses = {
    '2xs': 'text-[0.65rem]',
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  const containerClasses =
    placement === 'horizontal'
      ? 'flex items-center gap-4'
      : 'flex flex-col items-center space-y-4';

  const textContainerClasses =
    placement === 'horizontal' ? 'text-left' : 'text-center';

  return (
    <div className={`h-full p-4 ${containerClasses} ${className}`}>
      <div className="rounded-full bg-danger-50 flex items-center justify-center p-2">
        <ExclamationCircleIcon
          className={`${iconSizeClasses[size]} text-danger-500`}
          strokeWidth={2}
        />
      </div>

      <div className={`space-y-1 ${textContainerClasses}`}>
        <Typography
          variant="paragraph"
          className={`text-gray-900 font-medium ${textSizeClasses[size]}`}
        >
          {title}
        </Typography>
        <Typography
          variant="small"
          className={`text-gray-600 ${descriptionSizeClasses[size]}`}
        >
          {description}
        </Typography>
      </div>

      {onAction && (
        <Button
          variant={variant}
          appearance={appearance}
          onClick={onAction}
          className={`${placement === 'horizontal' ? '' : 'mt-2'}`}
          size={size}
        >
          {actionContent}
        </Button>
      )}
    </div>
  );
};
